module.exports = __webpack_public_path__ + "static/media/surveyor.d42b331a.jpg";